import { useEffect, useState } from "react";
import { HeartPulse } from "lucide-react";
import { useNavigate } from "@/hooks/useDeskNavigate";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { LEVEL } from "@/components/settings/SystemHealthPanel";

const CSS = `@keyframes hp-pulse{0%,100%{transform:scale(1)}50%{transform:scale(1.18)}}.hp-beat{animation:hp-pulse 2.4s ease-in-out infinite}`;

/** Icône heart-pulse 18 px de la barre de profil (admins) : couleur par niveau, pulsation rouge, bulle (orange/rouge), clic → Paramètres › Santé. */
export default function HealthPulseIcon() {
  const { user } = useAuth();
  const nav = useNavigate();
  const [s, setS] = useState(null);
  const [hover, setHover] = useState(false);
  const admin = user?.role === "admin" || user?.is_first_admin;
  useEffect(() => {
    if (!admin) return;
    let alive = true;
    const tick = () => api.get("/settings/system-health/summary").then(({ data }) => alive && setS(data)).catch(() => {});
    tick(); const id = setInterval(tick, 5 * 60 * 1000);
    return () => { alive = false; clearInterval(id); };
  }, [admin]);
  if (!admin) return null;
  const dangers = (s?.anomalies || []).filter((a) => a.level === "red").length + (s?.level === "red" ? 1 : 0);
  const color = dangers > 0 ? "#ef8a7a" : "#4fc79c"; // Ch. 5/B10 : vert sans « Danger », rouge dès un « Danger »
  const n = s?.anomalies?.length || 0;
  return (
    <span className="relative inline-flex" onMouseEnter={() => setHover(true)} onMouseLeave={() => setHover(false)}>
      <style>{CSS}</style>
      <button type="button" onClick={() => nav("/parametres?tab=health")} title="Santé système" className="inline-flex items-center justify-center topbar-slot" style={{ width: 34, height: 30, borderRadius: 16, background: "transparent", border: "none" }} data-testid="health-pulse-icon" data-level={dangers > 0 ? "red" : "green"}>
        <HeartPulse size={18} className="hp-beat" style={{ color }} />
      </button>
      {hover && n > 0 && (
        <span className="absolute" style={{ top: "calc(100% + 6px)", right: 0, zIndex: 300, width: 260, background: "#1c1c22", border: `0.5px solid ${color}`, borderRadius: 10, padding: "9px 11px", boxShadow: "0 8px 24px rgba(0,0,0,.45)" }} data-testid="health-pulse-tip">
          <span className="block" style={{ fontSize: 11, fontWeight: 700, color, marginBottom: 5 }}>{n} anomalie{n > 1 ? "s" : ""} — Santé système</span>
          {s.anomalies.slice(0, 5).map((a) => <span key={a.key} className="flex items-center justify-between" style={{ gap: 8, fontSize: 10.5, color: "#d6d6dc", padding: "2px 0" }}><span className="truncate">{a.label}</span><span style={{ color: LEVEL[a.level] || LEVEL.green, whiteSpace: "nowrap" }}>{a.summary}</span></span>)}
          <span className="block" style={{ fontSize: 9.5, color: "#6f6f78", marginTop: 5 }}>Cliquer pour ouvrir Paramètres › Santé</span>
        </span>)}
    </span>
  );
}
